import SearchForm from "./SearchForm";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  submitSearch,
  loadSuggestions,
  getVisibility,
  closeSearch,
  getResultVisibility,
  setSearchTerm,
  getSearchTerm,
  isSearchResultsPanelOpen,
  openSearch
} from "../../state/modules/search";
import { getViewport } from "../../state/modules/layout";
import {
  getDefaultStoreUrl,
  getSearchUrl
} from "../../state/modules/regionalStore";
import { isFeatureActive } from "../../state/modules/features";

function mapStateToProps(state) {
  return {
    isVisible: getVisibility(state),
    hasVisibleResults: getResultVisibility(state),
    viewport: getViewport(state),
    term: getSearchTerm(state),
    isSearchResultsPanelOpen: isSearchResultsPanelOpen(state),
    searchUrl: getSearchUrl(state),
    storeUrl: getDefaultStoreUrl(state),
    useModernSearchURL: isFeatureActive(state, "stc-use-modern-search-url")
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSearch: submitSearch,
      loadSuggestions: loadSuggestions,
      setSearchTerm: setSearchTerm,
      closeSearch: closeSearch,
      openSearch: openSearch
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);



// WEBPACK FOOTER //
// ./template/components/SearchForm/index.js